import z from 'zod';
import { datetime, string } from './zod';
export var FeatureType;
(function (FeatureType) {
    FeatureType["Point"] = "Point";
    FeatureType["Polygon"] = "Polygon";
    FeatureType["MultiPolygon"] = "MultiPolygon";
})(FeatureType || (FeatureType = {}));
export const resolvedPositionAddress = z.object({
    countryCode: string.nullish(),
    state: string.nullish(),
    city: string.nullish(),
    streetName: string.nullish(),
    streetNumber: string.nullish(),
    floor: z.number().nullish(),
    formattedAddress: string.optional(),
});
export const resolvedPositionProperties = z.object({
    accuracy: z.number().optional(),
    heading: z.number().optional(),
    headingAccuracy: z.number().optional(),
    speed: z.number().optional(),
    speedAccuracy: z.number().optional(),
    altitude: z.number().optional(),
    altitudeAccuracy: z.number().optional(),
    address: resolvedPositionAddress.optional(),
    dateTime: datetime.optional(),
    provider: string.optional(),
});
export const lonLat = z.tuple([z.number(), z.number()]);
export const pointGeometry = z.object({
    type: z.literal(FeatureType.Point),
    coordinates: lonLat,
    properties: resolvedPositionProperties,
});
export const polygonGeometry = z.object({
    type: z.literal(FeatureType.Polygon),
    coordinates: lonLat.array().array(),
    properties: resolvedPositionProperties,
});
export const multiPolygonGeometry = z.object({
    type: z.literal(FeatureType.MultiPolygon),
    coordinates: lonLat.array().array().array(),
    properties: resolvedPositionProperties,
});
export const anyPolygonGeometry = z.discriminatedUnion('type', [
    polygonGeometry,
    multiPolygonGeometry,
]);
export const anyGeometry = z.discriminatedUnion('type', [
    pointGeometry,
    polygonGeometry,
    multiPolygonGeometry,
]);
